export default __webpack_public_path__ + "static/media/main-couple.86346b6c.png";